
import React from 'react';
import { CustomAvatarGroup } from '@/components/custom/CustomAvatarGroup';
import { Users } from 'lucide-react';

interface Attendee {
  full_name: string;
  avatar_url?: string | null;
  guest_avatar_url?: string | null;
  rsvp_status?: string;
  isHost?: boolean;
  user_id?: string;
  invite_id?: string;
}

interface AttendeeAvatarsProps {
  attendees: Attendee[];
}

export const AttendeeAvatars = ({ attendees }: AttendeeAvatarsProps) => {
  if (!attendees.length) return null;

  return (
    <div className="flex items-center gap-2 rounded-full px-3 py-1 border border-gray-200 w-fit">
      <CustomAvatarGroup 
        users={attendees.map(attendee => ({
          full_name: attendee.full_name,
          avatar_url: attendee.avatar_url,
          guest_avatar_url: attendee.guest_avatar_url,
          rsvp_status: attendee.rsvp_status as 'accepted' | 'declined' | 'invited' | 'maybe',
          isHost: attendee.isHost,
          // Ensure we have a unique identifier for each attendee
          user_id: attendee.user_id || attendee.invite_id
        }))} 
        maxVisible={4}
        size="sm"
      />
      <span className="text-sm text-gray-600 flex items-center gap-1">
        <Users size={14} />
        {attendees.length}
      </span>
    </div>
  );
};
